import { Component, OnInit, ViewChild } from '@angular/core';
import { SuperComponent } from '../../super/super.component';
import { TranslateService } from '@ngx-translate/core';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { CheckValidation } from 'src/app/shared/services/hr/CheckValidation.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { publicSettingService } from 'src/app/shared/services/hr/publicSetting';
import { NotifyService } from 'src/app/shared/services/hr/notify.service';
import { Router } from '@angular/router';
import { EmployeeService } from 'src/app/shared/services/hr/employee.service';
import { DxDataGridComponent } from 'devextreme-angular';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-employee-attachment',
  templateUrl: './employee-attachment.component.html',
  styleUrls: ['./employee-attachment.component.scss']
})
export class EmployeeAttachmentComponent extends SuperComponent implements OnInit {
  allemployeeAttacment:any =[];
  employeeMenu:any =[];
  AttacmentMenu:any =[];

  @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;

  constructor(Objects: ObjectsService, translate: TranslateService,private employeeService: EmployeeService ,private router:Router,private publicSetting: publicSettingService, private NotifyService: NotifyService, private validation: CheckValidation, gt: genericCustomStoreService) {
    super(Objects, translate, gt)
  }

  ngOnInit(): void {
    this.getEmployeeMenu();
    this.getEmployeeAttachmentMenu();
    this.getAllEmployeeAttachment();
  }

  getEmployeeMenu () {
    this.gt.getdropdown('Employee').subscribe((res:any)=> {
      // this.employeeMenu = res.data;
      this.employeeMenu = res;
      console.log("employeeMenu", res)
    })
  }

  getEmployeeAttachmentMenu () {
    this.gt.getdropdowndata('EmployeeAttachmentTypes').subscribe((res:any)=> {
      this.AttacmentMenu = res;
      console.log("AttacmentMenu", res)
    })
  }

  getAllEmployeeAttachment () {
    this.publicSetting.getAll('EmployeeAttachment').subscribe((res: any)=> {     
      res.forEach((element: any) => {
        element.createdOnDate = element.createdOn?.split('T')[0];
        element.createdOnTime = element.createdOn?.split('T')[1].split('.')[0];
      }); 
      this.allemployeeAttacment = res;
      console.log("allemployeeAttacment", res)
    })
  }

  openImage(imageUrl: any) {
    debugger;
  if (imageUrl.data.fileUrl) {
    //Files\60c1db50-35f9-4f6b-bbbc-82a86402e086.pdf
    window.open(environment.apiRoot+'/'+imageUrl.data.fileUrl, '_blank');
  }
}
  goToAddAttachment(e: any) {
    this.router.navigate(['hr/add-attachment']);
    this.employeeService.$Attachment_ID.next(e.key ? e.key: 0)
  }
}
